/* eslint-disable max-lines */
import { EBannerType, TGuideList } from 'shared/types/guide';
import { EOfferType } from 'shared/types/wantType';
import { AESTHETIC_INTERIOR, PLACE_AD } from './links';

export const SALE_GUIDE_LIST: TGuideList[] = [
  {
    step: 1,
    title: 'Подготовьте недвижимость к продаже',
    slider: [
      {
        image: 'ebb040b2-7f69-4c4c-8719-30346b827592.png',
        title: 'Как обустроить и украсить квартиру, чтобы продать ее быстрее?',
        notice: '6 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch-2-houm-stejdzhing-287784/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '05cf0bbf-1639-4706-a760-e8a1654a5339.png',
        title: 'Список документов, которые стоит собрать еще до продажи квартиры',
        notice: '6 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-spisok-dokumentov-kotorye-stoit-sobrat-esche-do-prodazhi-kvartiry-327328/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '1cc26393-23c6-406e-8d7b-cfdf40c12073.png',
        title: 'Семь простых правил, чтобы удачно сфотографировать квартиру',
        notice: '10 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-sem-prostyh-pravil-chtoby-udachno-sfotografirovat-kvartiru-317104/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '75525281-c753-4772-a916-fdfb658e39a6.png',
        title: 'Как правильно оценить свою квартиру',
        notice: '11 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-kak-pravilno-otsenit-svoju-kvartiru-327064/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'b0145d98-ffd3-4cc9-ab95-7e7c3235e564.png',
        title: 'Как быстро продать квартиру: советы риелторов и юристов',
        notice: '8 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-kak-bystro-prodat-kvartiru-sovety-rieltorov-i-juristov-327840/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'e47e8780-2535-415b-b058-75f9d7575360.png',
        title: 'Как выбрать идеальный момент для продажи квартиры',
        notice: '7 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-vybiraem-idealnyj-moment-dlja-prodazhi-kvartiry-327321/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '23326d9a-495d-4e18-9851-b6b2e524d5ae.png',
        title: 'Продажа квартиры: составьте план, чтобы ничего не упустить',
        notice: '9 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-prodazha-kvartiry-sostavte-plan-chtoby-nichego-ne-upustit-327350/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'dda87dcc-8b5c-4e60-9cc3-e5f5f356f4f4.png',
        title: 'Как красиво сфотографировать загородный дом для продажи?',
        notice: '9 мин. чтения',
        type: EOfferType.Suburban,
        link: 'https://www.cian.ru/stati-kak-krasivo-sfotografirovat-zagorodnyj-dom-dlja-prodazhi-ili-sdachi-v-arendu-331455/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '7f91a79c-652a-4b35-be55-417f3cb294e0.png',
        title: 'Инструкция: как продать загородный дом',
        notice: '9 мин. чтения',
        type: EOfferType.Suburban,
        link: 'https://www.cian.ru/stati-instruktsija-kak-prodat-zagorodnyj-dom-316069/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '6593a1f0-97c4-4046-9314-de595748464c.png',
        title: 'Статусы земельных участков: правовой гид',
        notice: '9 мин. чтения',
        type: EOfferType.Suburban,
        link: 'https://cian.ru/stati-raznye-statusy-zemelnyh-uchastkov-pravovye-posledstvija-dlja-pokupatelja-290105/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '5568d538-65ea-4436-b3a4-c2444c54566e.png',
        title: 'Кадастровый учет. Как привести документы на землю в порядок?',
        notice: '9 мин. чтения',
        type: EOfferType.Suburban,
        link: 'https://www.cian.ru/stati-kadastrovyj-uchet-kak-privesti-v-porjadok-dokumenty-na-zemlju-286171/?cian_source=guide&cian_medium=sale',
      },
    ],
  },
  {
    step: 2,
    title: 'Создайте эффективное объявление',
    slider: [
      {
        image: 'bb0690ad-430f-4949-866c-e32652eaae93.png',
        title: 'Как написать удачное объявление о продаже? Разбираем по пунктам',
        notice: '8 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-kak-napisat-udachnoe-objavlenie-o-prodazhe-razbiraem-po-punktam-327320/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '0629f676-fc37-4b80-bf40-bb27418e54c5.png',
        title: 'Как создать привлекательную страницу объявления?',
        notice: '5 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-privlech-bolshe-vnimanija-k-svoemu-objavleniju-na-tsian-333459/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '9944277b-53f4-4eed-9b94-15abd6995cce.png',
        title: 'Пошаговая инструкция, как разместить объявление на Циан',
        notice: '5 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-poshagovaja-instruktsija-kak-razmestit-objavlenie-na-tsian-332829/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '73a36b16-d39b-4098-8f19-98a3a526ca66.png',
        title: 'Восемь лайфхаков, как продать квартиру максимально выгодно',
        notice: '5 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-vosem-lajfhakov-kak-prodat-kvartiru-maksimalno-vygodno-327316/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '83b60bd0-0843-4ccc-b6c7-39eb53e13497.png',
        title: 'Что делать, если никто не звонит по объявлению о продаже дома',
        notice: '5 мин. чтения',
        type: EOfferType.Suburban,
        link: 'https://www.cian.ru/stati-chto-delat-esli-po-objavleniju-o-prodazhe-doma-ne-zvonjat-332335/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'f19fe0e1-1bf3-4089-9bf8-b39b4532440f.png',
        title: 'Как правильно заполнить объявление о продаже дома: советы покупателей',
        notice: '5 мин. чтения',
        type: EOfferType.Suburban,
        link: 'https://www.cian.ru/stati-kak-pravilno-zapolnit-objavlenie-o-prodazhe-doma-sovety-pokupatelej-330251/?cian_source=guide&cian_medium=sale',
      },
    ],
    banner: {
      mainBanner: {
        type: EBannerType.Blue,
        title: 'Размещайтесь на Циан',
        linkBtn: { url: PLACE_AD, text: 'Разместить объявление' },
        imageClass: 'cian-pin',
      },
    },
  },
  {
    step: 3,
    title: 'Принимайте звонки и общайтесь с потенциальными покупателями в чатах',
    slider: [
      {
        image: 'ac567a46-b263-4f45-808f-c1d2691e4a89.png',
        title: 'Звонки по объявлению — как правильно разговаривать с покупателем?',
        notice: '7 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch10-zvonki-po-objavleniju-kak-razgovarivat-287947/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'c78dce01-48ad-444a-891e-4b922e86882c.png',
        title: 'Как общаться в чатах с покупателями?',
        notice: '5 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-obschatsja-s-pokupateljami-v-chatah-chtoby-bystree-prodat-kvartiru-333097/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '31da3aa4-4b6e-48ab-95f9-e5ad23ed22b6.png',
        title: 'Как управлять ценой в объявлении, чтобы ускорить продажу и не «продешевить»?',
        notice: '7 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-upravljaem-tsenoj-v-objavlenii-kak-prodat-svoj-obekt-bystro-i-ne-prodeshevit-333279/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '7f6b4e9e-2e25-4c4a-bf13-a0f347c45a34.png',
        title: 'По объявлению о продаже мало звонков? Рассказываем, что делать',
        notice: '7 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-po-objavleniju-o-prodazhe-nikto-ne-zvonit-rasskazyvaem-chto-delat-327312/?cian_source=guide&cian_medium=sale',
      },
    ],
  },
  {
    step: 4,
    title: 'Как провести показ',
    slider: [
      {
        image: '4c8a694d-4324-402c-a42d-8132a0ad3bdc.png',
        title: 'Без права на повтор: как правильно показывать квартиру',
        notice: '10 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-bez-prava-na-povtor-kak-pravilno-pokazyvat-kvartiru-327317/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'a171aadc-4128-4798-95ee-65c29a921e6f.png',
        title: 'С продажей квартиры что-то пошло не так. Что делать?',
        notice: '7 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-s-prodazhej-kvartiry-chto-to-poshlo-ne-tak-chto-delat-327315/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'ebb040b2-7f69-4c4c-8719-30346b827592.png',
        title: 'Предпродажная подготовка: советы по подготовке квартиры к показам',
        notice: '6 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch-2-houm-stejdzhing-287784/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'e1c77741-4f03-4a60-915d-65b4f3319b5a.png',
        title: 'Аванс и задаток: что выгоднее для продавца загородной недвижимости',
        notice: '6 мин. чтения',
        type: EOfferType.Suburban,
        link: 'https://www.cian.ru/stati-avans-ili-zadatok-chto-vygodnee-dlja-prodavtsa-zagorodnoj-nedvizhimosti-332531/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '56cf9f52-2ed9-446b-91a6-ac77260fc716.png',
        title: 'Показы загородного дома: руководство для продавцов',
        notice: '6 мин. чтения',
        type: EOfferType.Suburban,
        link: 'https://spb.cian.ru/stati-pokazy-zagorodnogo-doma-rukovodstvo-dlja-prodavtsov-332995/?cian_source=guide&cian_medium=sale',
      },
    ],
    banner: {
      mainBanner: {
        type: EBannerType.Colored,
        title: 'Как избежать ошибок при продаже квартиры?',
        linkBtn: {
          text: 'Узнать больше',
          url: 'https://spb.cian.ru/stati-shest-oshibok-sobstvennika-pri-prodazhe-kvartiry-336018/?cian_source=guide&cian_medium=sale',
        },
        imageClass: 'town',
      },
      secondBanner: {
        type: EBannerType.Colored,
        title: 'Как создать эстетичный интерьер, чтобы легко продать или сдать свою недвижимость',
        linkBtn: {
          text: 'Узнать больше',
          url: AESTHETIC_INTERIOR,
        },
        imageClass: 'house',
      },
    },
  },
  {
    step: 5,
    title: 'Как заключить договор',
    slider: [
      {
        image: '1432f318-e0f4-443e-947a-8d69cc00308a.png',
        title: 'Как проходит сделка по продаже недвижимости: пошаговая инструкция',
        notice: '6 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-prohodit-sdelka-po-prodazhe-kvartiry-poshagovaja-instruktsija-327334/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '4bf51cd6-30df-46e2-b232-413efd6023dc.png',
        title: 'Чек-лист для документов, которые потребуются при продаже квартиры',
        notice: '9 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-chek-list-dlja-dokumentov-kotorye-potrebujutsja-pri-prodazhe-kvartiry-327333/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '3d4b70fd-6f8a-4306-81f0-1a573dc50302.png',
        title: 'Как составить договор купли-продажи, чтобы ничего не забыть? Инструкция',
        notice: '8 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-sostavit-dogovor-kupli-prodazhi-chtoby-nichego-ne-zabyt-instruktsija-314940/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '2d10746a-6c83-445d-b535-bd666f261e4d.png',
        title: 'Предварительный договор купли-продажи недвижимости: зачем и когда он нужен',
        notice: '15 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-predvaritelnyj-dogovor-kupli-prodazhi-nedvizhimosti-zachem-i-kogda-on-nuzhen-327570/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '1d5943c5-e118-48ac-974a-cd44a83f9a48.png',
        title: 'Как правильно передать квартиру покупателю',
        notice: '4 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-kak-pravilno-peredat-kvartiru-pokupatelju-327325/?cian_source=guide&cian_medium=sale',
      },
    ],
  },
  {
    step: 6,
    title: 'Разбираемся в тонкостях',
    slider: [
      {
        image: '4f37406b-0fbf-47c0-ad1c-c12ce2ca83e4.png',
        title: 'Какие могут быть сложности при продаже квартиры?',
        notice: '6 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-kakie-mogut-byt-slozhnosti-pri-prodazhe-kvartiry-327324/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '481636ba-993a-409b-aa81-12c2324470b6.png',
        title: 'Миссия выполнима: продажа квартиры по доверенности',
        notice: '8 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-missija-vypolnima-prodazha-kvartiry-po-doverennosti-299792/?cian_source=guide&cian_medium=sale',
      },
      {
        image: 'ea86f4e2-8cc0-4e72-90de-d19ef7edb3f5.png',
        title: 'Когда и как выписываться из квартиры при ее продаже',
        notice: '8 мин. чтения',
        type: EOfferType.Apartment,
        link: 'https://www.cian.ru/stati-kogda-i-kak-vypisyvatsja-iz-kvartiry-pri-ee-prodazhe-327310/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '7f68a74f-aa2d-4dad-a7cc-736a2bb47d08.png',
        title: 'Кадастровая стоимость недвижимости: зачем она нужна, как ее узнать и оспорить',
        notice: '8 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-otsenka-zachem-nuzhna-kadastrovaja-stoimost-zhilja-301143/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '4bf54e86-d673-4488-8c2e-119b88ca733b.png',
        title: 'Налог на недвижимость: кто, сколько и когда должен платить',
        notice: '16 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-nalog-na-nedvizhimost-kto-skolko-i-kogda-dolzhen-platit-327622/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '56e66f21-99d7-4157-9ecb-93a9c8432add.png',
        title: 'Как продать недвижимость и не платить налог?',
        notice: '14 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-prodat-kvartiru-i-ne-platit-nalog-315517/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '05548355-16f3-4247-bf7b-691d0c2f15b9.png',
        title: 'Как подать налоговую декларацию при продаже жилья: ответы на вопросы и пример',
        notice: '16 мин. чтения',
        type: 'all',
        link: 'https://www.cian.ru/stati-kak-podat-nalogovuju-deklaratsiju-pri-prodazhe-zhilja-otvety-na-voprosy-i-primer-331994/?cian_source=guide&cian_medium=sale',
      },
      {
        image: '5a4ebdcd-5212-4cb4-b4aa-c7cfe9cb3ebe.png',
        title: 'Ошибки в налогах, или как не платить лишнего за недвижимость',
        notice: '16 мин. чтения',
        type: 'all',
        link: 'https://spb.cian.ru/stati-oshibki-v-nalogah-ili-kak-ne-platit-lishnego-za-nedvizhimost-330749/?cian_source=guide&cian_medium=sale',
      },
    ],
  },
];
